import React from 'react';
import root from 'window-or-global';
import cx from 'classnames';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import semver from 'semver';
import QRCode from 'qrcode-react';
import {generateRoutePath} from 'epic-common/src/route';
import BackgroundVideo from 'epic-react-common/src/components/BackgroundVideo';
import EGSDownloadImage from 'epic-react-common/src/components/EGSDownloadImage';
import GalaxyAppsImage from 'epic-react-common/src/components/GalaxyAppsImage';
import epicTracking from 'epic-tracking';
import {getLocale} from 'epic-common/src/locale';


export default class GetStarted extends React.PureComponent {
    static propTypes = {
        data: PropTypes.object,
        mobile: PropTypes.bool,
        isAndroid: PropTypes.bool,
        osVersion: PropTypes.string,
        isSamsung: PropTypes.bool,
        shouldShowGooglePlayStore: PropTypes.bool,
        googlePlayIcon: PropTypes.string,
        samsungData: PropTypes.object,
        supportedDevices: PropTypes.object
    };

    state={
        drawerActive: false,
        mute: true
    };

    toggleDrawer = (title) => {
        this.setState({
            drawerActive: !this.state.drawerActive
        });
        epicTracking.trackEvent('Interaction', {
            interactionType: 'click',
            eventCategory: 'fortnite Android',
            eventAction: 'Toggle Drawer',
            eventLabel: title
        });
    }

    toggleAudio = () => {
        this.setState({
            mute: !this.state.mute
        });
    }

    trackClick(title) {
        epicTracking.trackEvent('Interaction', {
            interactionType: 'click',
            eventCategory: 'Battle Breakers Android',
            eventAction: 'Download',
            eventLabel: title
        });
    }

    render() {
        const locale = getLocale();
        const {
            data, mobile, isAndroid, osVersion, isSamsung, samsungData, supportedDevices, shouldShowGooglePlayStore, googlePlayIcon
        } = this.props;
        const link = root.location.href;
        const {
            title, subtitle, description, video, image, playStoreLink
        } = data;
        const {
            samsungLink
        } = samsungData;

        const img = mobile ? image.tabletImage : image.desktopImage;

        //show QR CODE
        if (!isAndroid) {
            return (
                <div className="getStarted text-center container">
                    <div className="contentWrapper">
                        <div className="notAndroidMessage text-center">
                            <div dangerouslySetInnerHTML={{__html: data.notAndroid}} />
                            <div className="qrContainer">
                                <QRCode value={link} size={150} level="M" />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        //direct user to correct flow based on UserAgent
        const oldVersion = semver.satisfies(semver.coerce(osVersion), '5.x.x - 7.x.x');
        const newVersion = semver.satisfies(semver.coerce(osVersion), '>=8.x.x');
        let goToPath = generateRoutePath('/mobile/android/not-supported');
        if (newVersion) {
            goToPath = generateRoutePath('/mobile/android/new-device');
        }
        if (oldVersion) {
            goToPath = generateRoutePath('/mobile/android/old-device');
        }
        return (
            <div className="getStarted">
                {video ? (
                    <div className="videoContainer embed-responsive embed-responsive-16by9">
                        <BackgroundVideo
                            background={video}
                            play={true}
                            noOverlay
                            ytAutohide
                            ytControls
                            playsInline={true}
                            mute={this.state.mute}
                            loop={true}
                            launcher={false}
                            forceVideoMobile />
                        <div role="presentation" onClick={this.toggleAudio} className="mute text-center">
                            {this.state.mute ? (
                                <i className="icon-mute" />
                            ) : (
                                <i className="icon-volume" />
                            )}
                        </div>
                    </div>
                ) : null}
                <div className="content-container">
                    {!video ? (
                        <div>
                            <div className="heroes" />
                            <img src={img} alt={title} className="img-responsive" />
                        </div>
                    ) : null}
                    <div className="container-fluid">
                        <div className="row headline">
                            <div className="col-xs-12 text-center">
                                <h1>{title}</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 text-center">
                                <div className="btnWrapper">
                                        <Link
                                            to={goToPath}
                                            id="androidDownloadBtn"
                                            onClick={() => this.trackClick('Epic Games Store')}
                                            className="btn">
                                            <EGSDownloadImage locale={locale} theme="DARK" />
                                        </Link>
                                {isSamsung ? (
                                        <a
                                            href={samsungLink}
                                            onClick={() => this.trackClick('Samsung')}
                                            className="">
                                            <GalaxyAppsImage locale={locale} />
                                        </a>
                                ) : null}
                                {
                                    shouldShowGooglePlayStore && googlePlayIcon ? 
                                    <a
                                        href={playStoreLink}
                                        onClick={() => this.trackClick('Google Play Store')}
                                        className="btn google-play-icon">
                                                <img src={googlePlayIcon} alt="google play store link"/>
                                        </a> : null
                                }
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 text-center download-description">
                                <p>{subtitle}</p>
                                <p className="small">{description}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 text-center">
                                <div
                                    role="presentation"
                                    onClick={() => this.toggleDrawer('Device Drawer')}
                                    className={cx('drawerContainer font_0', {active: this.state.drawerActive})}>
                                    <h6>{supportedDevices.btnText}<i className="icon-arrow" /></h6>
                                    <div
                                        className="drawer"
                                        dangerouslySetInnerHTML={{__html: supportedDevices.supportedDevices}} />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
